import { useCallback } from "react";
import { useDropzone } from "react-dropzone";

import './Style/DragAndDropFileUpload.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";

interface FileUploadProps {
    onFileUpload: (files: File[]) => void;
}

const DragAndDropFileUpload: React.FC<FileUploadProps> = ({ onFileUpload }) => {
    const onDrop = useCallback((acceptedFiles: File[]) => {
        onFileUpload(acceptedFiles);
    }, [onFileUpload]);
    
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });
    
    return (
        <>
            <div className="container">
                <div {...getRootProps()}
                    className={`wrapper border-2 border-dashed p-6 rounded-lg text-center cursor-pointer ${
                    isDragActive ? "border-blue-500 bg-blue-100" : "border-gray-400"
                    }`}
                >
                    <input {...getInputProps()} />
                    <p className="drag-zone">{
                        isDragActive ? 
                            <>
                                <FontAwesomeIcon icon={faFile} size="4x"/> 
                                Solte os arquivos aqui...  
                            </>
                            :
                            <>
                                <FontAwesomeIcon icon={faFile} size="4x"/> 
                                Arraste e solte arquivos aqui ou clique para selecionar
                            </>
                        }

                    </p>
                </div>
            </div>
        </>
    );
}

export default DragAndDropFileUpload